// extracted by mini-css-extract-plugin
export var startPage = "StartPage-module--startPage--vBzTq";
export var clownBg = "StartPage-module--clownBg--NNwaw";
export var startInner = "StartPage-module--startInner--zN0Ad";
export var imageJigsaw = "StartPage-module--imageJigsaw--aLn-b";
export var title = "StartPage-module--title--3F2sD";
export var text = "StartPage-module--text--EEo6Z";
export var buttonStart = "StartPage-module--buttonStart--CirTR";